import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import Pages
import Landing from './pages/Landing';
import Login from './pages/auth/login';
import AdminDashboard from './pages/admin/admindashboard';
import AdminReports from './pages/admin/adminreports';
import AdminGuests from './pages/admin/adminguests';
import AdminBilling from './pages/admin/adminbilling';
import AdminRooms from './pages/admin/adminrooms';

// Import Admin Components
import AdminLayout from './components/admin/adminlayout';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Default Landing Page */}
          <Route path="/" element={<Landing />} />
          
          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Admin Routes with Layout */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="guests" element={<AdminGuests />} />
            <Route path="billing" element={<AdminBilling />} />
            <Route path="rooms" element={<AdminRooms />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;